import {UseToast} from "../hooks/useToast";
import axios, {AxiosResponse} from "axios";
import {AnnulPenaltyInvoice} from "../types/types";


export class PenaltyInvoiceService {
    private readonly url: string;
    private readonly toastHelpers: Pick<UseToast, 'showDeletedToast' | 'showUpdatedToast' | 'showCreatedToast' | 'showToast'>
    private readonly f: any;

    constructor(f: any, toastHelpers: Pick<UseToast, 'showDeletedToast' | 'showUpdatedToast' | 'showCreatedToast' | 'showToast'>) {
        this.toastHelpers = toastHelpers;
        this.f = f;
        this.url = '/penaltyInvoices';
    }

    async annulPenaltyInvoice(annulPenaltyInvoice: AnnulPenaltyInvoice) {
        return new Promise<boolean>((resolve, reject) => {
            axios.put<boolean>(this.url, annulPenaltyInvoice)
                .then(resp => {
                    if (resp.data) {
                        resolve(resp.data);
                        this.toastHelpers.showToast("success", this.f({id: 'operationSuccessful'}), `${this.f({id: 'invoice'})} ${resp.data}`, false);
                    } else {
                        reject(false);
                        this.toastHelpers.showToast("error", this.f({id: 'operationUnsuccessful'}), '', false);
                    }
                }).catch(err => {
                reject(err);
                this.toastHelpers.showToast("error", this.f({id: 'operationUnsuccessful'}), '', false);
            })
        })
    }
   

    async downloadPenaltyInvoice(penaltyInvoiceId: number) {
        return new Promise<any>((resolve, reject) => {
            axios.post(`${this.url}/${penaltyInvoiceId}` ,{}, { responseType: 'arraybuffer' }).then(response => {
                const blob = new Blob([response.data], {
                    type: response.headers['content-type'],
                });
                resolve(blob);
            }).catch(reject);
        })
    }

    async exportExcel(penaltyInvoiceIds: number[]) {
        return new Promise<AxiosResponse<BlobPart>>((resolve, reject) => {
            axios.post<BlobPart>(`${this.url}/generateExcel` ,penaltyInvoiceIds, { responseType: 'arraybuffer' }).then(response => {
                resolve(response);
            }).catch(reject);
        })
    }

    async deletePenaltyInvoiceFile(deletePenaltyInvoiceFileModel: AnnulPenaltyInvoice) {
        return new Promise<boolean>((resolve, reject) => {
            axios.post<boolean>(`${this.url}/annul`, deletePenaltyInvoiceFileModel).then(resp => {
                this.toastHelpers.showToast('success', this.f({id: 'operationSuccessful'}), "");
                resolve(true);
            }).catch(reject)
        })
    }

}
